import ActionsForm from '@/shared/mixins/actionsForm'
import CompanyMixin from '@/store/module/company/mixin'
import Form from './serviceanalysistec-form'
import Data from '@/shared/models/pci/tecserviceanalysismodel'
import ServiceAnalysisTecRepository from '@/shared/http/repositories/pci/tecserviceanalysis'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'ServiceAnalysisTec',
  mixins: [ActionsForm, CompanyMixin],
  components: {

  },
  data () {
    return {
      objList: [],
      form: Form,
      data: Data,
      serviceTypeOptions: []
    }
  },
  methods: {
    onLoad () {
      this.onClearForm()
      this.serviceTypeOptions = []
      ServiceAnalysisTecRepository.GetAll()
        .then(response => {
          if (response.data.code > 0) {
            this.onResultGrid(response)
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
    },
    onSelect (data) {
      this.onEdit(data)
      this.$refs.txtDescricao.$el.focus()
    },
    onCreate () {
      loading.push()
      ServiceAnalysisTecRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.data.id = response.data.data.id
            this.onLoad()
            this.onSelect(response.data.data)
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      loading.push()
      ServiceAnalysisTecRepository.Update(this.data)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.data.id = response.data.data.id
            this.onLoad()
            this.onSelect(response.data.data)
          } else {
            toast.error(response.data.message || this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete (item) {
      loading.push()
      ServiceAnalysisTecRepository.Delete(item.id)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.onLoad()
          } else {
            toast.error(response.data.message || this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onClearForm () {
      this.onClear()
    },
    onSaveForm () {
      this.onSave()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/serviceanalysistec/serviceanalysistec.js